module.exports = __webpack_public_path__ + "img/1f957.048d5e0.svg";